import React from 'react';
import { tscope } from '@i18n';
import {
  Box,
  Text,
  Grid,
  Heading,
  Flex,
  Button,
  useDisclosure,
} from 'ui';
import { Link } from 'react-router-dom';
import { styles as s } from './UploadFormContainer.style';
import { ConfirmationModal } from '../ConfirmationModal';

const ts = tscope('Documents.formContent');

const preventDefault = (submitCallback = () => {}) => (e) => {
  e.preventDefault();
  submitCallback();
};

export const UploadFormContainer = ({
  t,
  type,
  children,
  onSubmit,
  imageElement = null,
  descriptionText,
  areDocumentsReady = false,
  ...props
}) => {
  const notice = t('notice', { defaultValue: '' });
  const cancel = t('actions.cancel', { defaultValue: ts('actions.cancel') });
  const submit = t('actions.submit', { defaultValue: ts('actions.submit') });

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Grid as="form" {...s.container} {...props} onSubmit={preventDefault(onSubmit)}>
      <Heading as="h3" {...s.title}>{t('title')}</Heading>
      <ConfirmationModal isOpen={isOpen} onClose={onClose} type={type} />
      <Grid {...s.document}>
        <Box {...s.image}>
          {imageElement}
        </Box>
        <Heading as="h4" {...s.subtitle}>{t('subtitle')}</Heading>
        <Text {...s.description}>{descriptionText || t('description')}</Text>
      </Grid>
      {notice && (<Text {...s.notice}>{notice}</Text>)}
      <Box {...s.content}>
        {children}
      </Box>
      <Flex {...s.actions}>
        <Button as={Link} to=".." variant="ghost">
          {cancel}
        </Button>
        <Button onClick={onOpen} isDisabled={!areDocumentsReady}>
          {submit}
        </Button>
      </Flex>
    </Grid>
  );
};
